// extracted by mini-css-extract-plugin
export default {"price-input":"PriceInput_price-input__I5uku","dollar-sign":"PriceInput_dollar-sign__rOXTH"};